import { School, Trophy } from "lucide-react";
import { useEffect } from "react";
import { FaUserGraduate } from "react-icons/fa";
import { GiTeacher } from "react-icons/gi";


const CounterSection = () => {
  const counters = [
    { icon: <FaUserGraduate size={'60'} />, value: 20000, suffix: "+", label: "Students Enrolled" },
    { icon: <School size={'60'} />, value: 15, suffix: "", label: "Branches" },
    { icon: <Trophy size={'60'} />, value: 100, suffix: "%", label: "Result" },
    { icon: <GiTeacher size={'60'} />, value: 800, suffix: "+", label: "Top Instructors" },
  ];

  useEffect(() => {
    const timers = document.querySelectorAll(".timer");

    timers.forEach((timer) => {
      const target = parseInt(timer.getAttribute("data-to"));
      const speed = parseInt(timer.getAttribute("data-speed")) || 10000;
      const suffix = timer.getAttribute("data-suffix") || "";

      let count = 0;
      const increment = target / (speed / 100);

      const updateCount = () => {
        count += increment;

        if (count < target) {
          timer.textContent = Math.ceil(count) + suffix;
          requestAnimationFrame(updateCount);
        } else {
          timer.textContent = target + suffix;
        }
      };

      updateCount();
    });
  }, []);

  return (
    <section className="space-ptb bg-dark">
      <div className="container">
        <div className="row">
          {counters.map((counter, index) => (
            <div
              key={index}
              className={`col-sm-6 col-lg-3 ${
                index < 3 ? "mb-4 mb-lg-0" : "mb-4 mb-md-0"
              }`}
            >
              <div className="counter text-start">
                <div className="counter-icon text-4xl text-primary mb-3">
                  <i className="text-white">{counter.icon}</i>
                </div>
                <div
                  className={`counter-content ${
                    index === 1 ? "align-self-center text-start justify-content-start" : ""
                  }`}
                >
                  <span
                    className="timer text-3xl font-bold"
                    data-to={counter.value}
                    data-suffix={counter.suffix}
                    data-speed="10000"
                  >
                    {counter.value}
                    {counter.suffix}
                  </span>
                  <label className="block text-lg text-white">{counter.label}</label>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CounterSection;